import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true, headers: { "X-Requested-With": "ilmora" } });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("ilmora-token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config;
    if (err.response?.status === 401 && !cfg._retry && !cfg.url.startsWith("/auth/")) {
      cfg._retry = true;
      try {
        const { data } = await api.post("/auth/refresh");
        localStorage.setItem("ilmora-token", data.access_token);
        return api(cfg);
      } catch {
        localStorage.removeItem("ilmora-token");
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ");
  return d.msg || String(d);
}
